// extracted by mini-css-extract-plugin
export default {"tableRoot":"lesson-reviews-table_tableRoot__FkVZC","reaction":"lesson-reviews-table_reaction__ehF10","reactionsContainer":"lesson-reviews-table_reactionsContainer__8jioz"};